module.exports = __webpack_public_path__ + "images/referenzen/imagefilm/tesa_mitarbeiterfilm_small.jpg";